// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MainMainLayoutRouteImport } from './routes/_main/main-layout'
import { Route as AdminAdminLayoutRouteImport } from './routes/admin/admin-layout'
import { Route as DraftDraftLayoutRouteImport } from './routes/draft/draft-layout'
import { Route as MainIndexRouteImport } from './routes/_main/index'
import { Route as MainOsRouteImport } from './routes/_main/os'
import { Route as MainReadmeReadmeLayoutRouteImport } from './routes/_main/readme/readme-layout'
import { Route as MainServicesRouteImport } from './routes/_main/services'
import { Route as MainStartRouteImport } from './routes/_main/start'
import { Route as MainWorksRouteImport } from './routes/_main/works'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAssetsRouteImport } from './routes/admin/assets'
import { Route as AdminBacklogRouteImport } from './routes/admin/backlog'
import { Route as AdminExampleMdRouteImport } from './routes/admin/example-md'
import { Route as AdminPlayMdRouteImport } from './routes/admin/play-md'
import { Route as DraftCrossfadeTextRouteImport } from './routes/draft/crossfade-text'
import { Route as DraftOsDemoRouteImport } from './routes/draft/os-demo'
import { Route as DraftThemePickerRouteImport } from './routes/draft/theme-picker'
import { Route as MainBuildSlugRouteImport } from './routes/_main/build.$slug'
import { Route as MainNoteSlugRouteImport } from './routes/_main/note/$slug'
import { Route as MainNotesIndexRouteImport } from './routes/_main/notes/index'
import { Route as MainReadmeRepoRouteImport } from './routes/_main/readme/$repo'
import { Route as MainReadmeSohanemonRouteImport } from './routes/_main/readme/sohanemon'
import { Route as MainResumeIndexRouteImport } from './routes/_main/resume/index'
import { Route as MainWorkSlugRouteImport } from './routes/_main/work.$slug'

const MainMainLayoutRoute = MainMainLayoutRouteImport.update({
            id: '/_main',getParentRoute: () => rootRouteImport
          })
const AdminAdminLayoutRoute = AdminAdminLayoutRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const DraftDraftLayoutRoute = DraftDraftLayoutRouteImport.update({
            id: '/draft',path: '/draft',getParentRoute: () => rootRouteImport
          })
const MainIndexRoute = MainIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MainMainLayoutRoute
          })
const MainOsRoute = MainOsRouteImport.update({
            id: '/os',path: '/os',getParentRoute: () => MainMainLayoutRoute
          })
const MainReadmeReadmeLayoutRoute = MainReadmeReadmeLayoutRouteImport.update({
            id: '/readme',path: '/readme',getParentRoute: () => MainMainLayoutRoute
          })
const MainServicesRoute = MainServicesRouteImport.update({
            id: '/services',path: '/services',getParentRoute: () => MainMainLayoutRoute
          })
const MainStartRoute = MainStartRouteImport.update({
            id: '/start',path: '/start',getParentRoute: () => MainMainLayoutRoute
          })
const MainWorksRoute = MainWorksRouteImport.update({
            id: '/works',path: '/works',getParentRoute: () => MainMainLayoutRoute
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminAdminLayoutRoute
          })
const AdminAssetsRoute = AdminAssetsRouteImport.update({
            id: '/assets',path: '/assets',getParentRoute: () => AdminAdminLayoutRoute
          })
const AdminBacklogRoute = AdminBacklogRouteImport.update({
            id: '/backlog',path: '/backlog',getParentRoute: () => AdminAdminLayoutRoute
          })
const AdminExampleMdRoute = AdminExampleMdRouteImport.update({
            id: '/example-md',path: '/example-md',getParentRoute: () => AdminAdminLayoutRoute
          })
const AdminPlayMdRoute = AdminPlayMdRouteImport.update({
            id: '/play-md',path: '/play-md',getParentRoute: () => AdminAdminLayoutRoute
          })
const DraftCrossfadeTextRoute = DraftCrossfadeTextRouteImport.update({
            id: '/crossfade-text',path: '/crossfade-text',getParentRoute: () => DraftDraftLayoutRoute
          })
const DraftOsDemoRoute = DraftOsDemoRouteImport.update({
            id: '/os-demo',path: '/os-demo',getParentRoute: () => DraftDraftLayoutRoute
          })
const DraftThemePickerRoute = DraftThemePickerRouteImport.update({
            id: '/theme-picker',path: '/theme-picker',getParentRoute: () => DraftDraftLayoutRoute
          })
const MainBuildSlugRoute = MainBuildSlugRouteImport.update({
            id: '/build/$slug',path: '/build/$slug',getParentRoute: () => MainMainLayoutRoute
          })
const MainNoteSlugRoute = MainNoteSlugRouteImport.update({
            id: '/note/$slug',path: '/note/$slug',getParentRoute: () => MainMainLayoutRoute
          })
const MainNotesIndexRoute = MainNotesIndexRouteImport.update({
            id: '/notes/',path: '/notes/',getParentRoute: () => MainMainLayoutRoute
          })
const MainReadmeRepoRoute = MainReadmeRepoRouteImport.update({
            id: '/$repo',path: '/$repo',getParentRoute: () => MainReadmeReadmeLayoutRoute
          })
const MainReadmeSohanemonRoute = MainReadmeSohanemonRouteImport.update({
            id: '/sohanemon',path: '/sohanemon',getParentRoute: () => MainReadmeReadmeLayoutRoute
          })
const MainResumeIndexRoute = MainResumeIndexRouteImport.update({
            id: '/resume/',path: '/resume/',getParentRoute: () => MainMainLayoutRoute
          })
const MainWorkSlugRoute = MainWorkSlugRouteImport.update({
            id: '/work/$slug',path: '/work/$slug',getParentRoute: () => MainMainLayoutRoute
          })





const MainReadmeReadmeLayoutRouteChildren = {
  MainReadmeRepoRoute: MainReadmeRepoRoute,MainReadmeSohanemonRoute: MainReadmeSohanemonRoute
}

const MainReadmeReadmeLayoutRouteWithChildren = MainReadmeReadmeLayoutRoute._addFileChildren(MainReadmeReadmeLayoutRouteChildren)



const MainMainLayoutRouteChildren = {
  MainReadmeReadmeLayoutRoute: MainReadmeReadmeLayoutRouteWithChildren,MainOsRoute: MainOsRoute,MainServicesRoute: MainServicesRoute,MainStartRoute: MainStartRoute,MainWorksRoute: MainWorksRoute,MainIndexRoute: MainIndexRoute,MainBuildSlugRoute: MainBuildSlugRoute,MainNoteSlugRoute: MainNoteSlugRoute,MainWorkSlugRoute: MainWorkSlugRoute,MainNotesIndexRoute: MainNotesIndexRoute,MainResumeIndexRoute: MainResumeIndexRoute
}

const MainMainLayoutRouteWithChildren = MainMainLayoutRoute._addFileChildren(MainMainLayoutRouteChildren)




const AdminAdminLayoutRouteChildren = {
  AdminAssetsRoute: AdminAssetsRoute,AdminBacklogRoute: AdminBacklogRoute,AdminExampleMdRoute: AdminExampleMdRoute,AdminPlayMdRoute: AdminPlayMdRoute,AdminIndexRoute: AdminIndexRoute
}

const AdminAdminLayoutRouteWithChildren = AdminAdminLayoutRoute._addFileChildren(AdminAdminLayoutRouteChildren)




const DraftDraftLayoutRouteChildren = {
  DraftCrossfadeTextRoute: DraftCrossfadeTextRoute,DraftOsDemoRoute: DraftOsDemoRoute,DraftThemePickerRoute: DraftThemePickerRoute
}

const DraftDraftLayoutRouteWithChildren = DraftDraftLayoutRoute._addFileChildren(DraftDraftLayoutRouteChildren)

const rootRouteChildren = {
  MainMainLayoutRoute: MainMainLayoutRouteWithChildren,AdminAdminLayoutRoute: AdminAdminLayoutRouteWithChildren,DraftDraftLayoutRoute: DraftDraftLayoutRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)